import { Button } from '../../../../components/Button'
import { useWatch, useFormContext } from 'react-hook-form'
import { useReceitaFederal } from '../../../../hooks/useReceitaFederal'
import { useEffect } from 'react'
import { useToast } from '@chakra-ui/react'

export function ConsultarReceita() {
  const { handleCnpj, data, error, isLoading } = useReceitaFederal()
  const { setValue } = useFormContext()
  const toast = useToast({
    status: 'error',
    position: 'top',
    duration: 5000,
  })

  const personType = useWatch({ name: 'personType' })
  const cnpjCpf = useWatch({ name: 'cnpjCpf' })

  const replacedCnpjCpf = cnpjCpf?.replace(/\D/g, '')

  const isDisabled = personType?.value === 'Pessoa Física' || !personType || replacedCnpjCpf?.length < 14

  async function handleConsultarReceita() {
    await handleCnpj(replacedCnpjCpf)
  }

  useEffect(() => {
    if (error) {
      toast({
        title: 'Erro ao consultar receita federal',
        description: 'Não foi possível consultar a receita federal',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    }

    if (data) {
      setValue('socialReason', data.RAZAO_SOCIAL)
      setValue('stateRegistration', data.INSCRICAO_ESTADUAL ? data.INSCRICAO_ESTADUAL : 'ISENTO')
      setValue('partnerName', data.RAZAO_SOCIAL)
      setValue('cep', data.CEP)
      setValue('neighborhood', data.BAIRRO)
      setValue('city', data.CIDADE)
      setValue('state', data.UF)
      setValue('street', data.ENDERECO)
      setValue('number', data.NUMERO_ENDERECO)
      setValue('icmsClassification', { value: data.CLASSIFICACAO_ICMS, label: data.CLASSIFICACAO_ICMS === 'C' ? 'Contribuinte' : 'Não contribuinte' })
      setValue('editar_endereco', false)
    }
  }, [data, setValue])

  useEffect(() => {
    //se for cpf é isento
    if (replacedCnpjCpf?.length === 11) {
      setValue('stateRegistration', 'ISENTO')
    }
  }, [replacedCnpjCpf, setValue])

  console.log(data)

  return (
    <Button disabled={isDisabled} onClick={handleConsultarReceita} isLoading={isLoading}>
      Consultar receita federal
    </Button>
  )
}
